import api from "./api.js";

export default class PopupApi {
  static async GetActivePopup(data) {
    return await api.get(`web/popups/active`, data);
  }
}
